import React from "react";
import DocumentAchatEntity from "./DocumentAchatEntity";

const BonReception = () => {
    return <DocumentAchatEntity type="Bon Reception" title="Bons Réception" endpoint="BonReception" />;
};

export default BonReception;
